import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cut_ic_triangle",
  "use": "icon-cut_ic_triangle-usage",
  "viewBox": "0 0 12 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 7\" id=\"icon-cut_ic_triangle\"><path d=\"M1.414 0h8.829a1 1 0 0 1 .707 1.707L6.536 6.121a1 1 0 0 1-1.415 0L.707 1.707A1 1 0 0 1 1.414 0z\" fill=\"#979799\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol